
export class AlertStatesBaseCountersModel {
  totalOpen: number;
  totalClosed: number;
  open: number;
  closed: number;
  openIds: string[];
  closedIds: string[];
}
